function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 21998"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 20008",
    style: {
      fill: "none"
    },
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17773",
    d: "M18 10a8 8 0 1 1-8-8 8 8 0 0 1 8 8zm-7-4a1 1 0 1 1-1-1 1 1 0 0 1 1 1zM9 9a1 1 0 0 0 0 2v3a1 1 0 0 0 1 1h1a1 1 0 0 0 0-2v-3a1 1 0 0 0-1-1z",
    transform: "translate(5 5)",
    style: {
      fill: "#0089ff",
      fillRule: "evenodd"
    }
  })));
};

export default SvgInfo;